import { Box, Typography } from '@mui/material'
import React from 'react'
import { EMPTY_OBJECT } from '../../utils/constants.jsx'

const PAGE_HEADER_SIZES = {
    default: {
        title: null,
        subtitle: { fontSize: "12px", color: "textSecondary" },
    },
    large: {
        title: { fontSize: { xs: 26, md: 32 }, fontWeight: 800, lineHeight: 1.1 },
        subtitle: { mt: 0.75, fontSize: 14, color: "text.secondary" },
    },
}

const PageHeader = ( { title, subtitle, size = 'default', sx = EMPTY_OBJECT } ) => {
    const sizeStyles = PAGE_HEADER_SIZES[ size ] || PAGE_HEADER_SIZES.default

    return (
        <Box sx={sx}>
            <Typography variant="h1" sx={sizeStyles.title}>
                {title}
            </Typography>
            {subtitle && <Typography variant="subtitle2" sx={sizeStyles.subtitle}>
                {subtitle}
            </Typography>}
        </Box>
    )
}

export default PageHeader
